<template>
  <div>
    <div ref='table' id='league-competition-rules' v-if='content !== ""'>
      <div>{{ $t('leagueCompetitionRules.title') }}</div>
      <div v-html="content"/>
    </div>
    <loadStateView :state='netState' :refreshHandle="loadData"/>
  </div>
</template>

<script>
import { checkEmptyObject } from '@/utils'

export default {
  name: 'league-competition-rules',
  props: {
    leagueId: {
      type: String
    },
    cupId: {
      type: String
    }
  },
  data () {
    return {
      content: ''
    }
  },
  activated () {
    this.loadData()
  },
  watch: {
    leagueId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {
      this.netState = checkEmptyObject(this.content) ? 1 : 0
      this.$dataBaseClient.get(`b_league/leagueFormat?leagueId=${this.leagueId ? this.leagueId : this.cupId}`)
        .then((response) => {
          this.netState = response.netState

          if (this.netState === 3) {
            this.content = ''
            return
          }

          this.content = response.Format
          console.log(response)
        })
        .catch((error) => {
          this.netState = 2
          console.log(error)
        })
    }
  }
}
</script>

<style lang="sass" scoped>
#league-competition-rules
  padding: 15px

  > div:nth-child(1)
    margin-bottom: 15px
    font-weight: bold
    font-size: 16px
    color: #333333

  > div:nth-child(2)
    font-size: 14px
    color: #666666
    white-space: pre-line
    line-height: 1.5

</style>
